var _slicedToArray = require("/Users/murillojuan/projects/shipyard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/murillojuan/projects/shipyard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/murillojuan/projects/shipyard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

// https://github.com/john-guerra/Navio#readme v0.0.38 Copyright 2019 John Alexis Guerra Gómez
!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e(require("d3"), require("d3-scale-chromatic"), require("popper.js")) : "function" == typeof define && define.amd ? define(["d3", "d3-scale-chromatic", "popper.js"], e) : t.navio = e(t.d3, t.d3ScaleChromatic, t.Popper);
}(this, function (t, e, n) {
  "use strict";

  n = n && n.hasOwnProperty("default") ? n.default : n;

  var o =
  /*#__PURE__*/
  function () {
    function o(t) {
      _classCallCheck(this, o);

      this.first = t.first, this.last = t.last, this.level = t.level, this.itemAttr = t.itemAttr;
    }

    _createClass(o, [{
      key: "filter",
      value: function filter(t) {
        return t.__i[this.level] >= this.first.__i[this.level] && t.__i[this.level] <= this.last.__i[this.level];
      }
    }, {
      key: "toStr",
      value: function toStr() {
        var t = "".concat(this.first[this.itemAttr]),
            e = "".concat(this.last[this.itemAttr]);
        return t = "string" == typeof this.first[this.itemAttr] ? t.slice(0, 5) : t, e = "string" == typeof this.first[this.itemAttr] ? e.slice(0, 5) : e, "".concat(this.itemAttr, " range including ").concat(t, " to ").concat(e);
      }
    }]);

    return o;
  }();

  var r =
  /*#__PURE__*/
  function () {
    function r(t) {
      _classCallCheck(this, r);

      this.itemAttr = t.itemAttr, this.sel = t.sel;
    }

    _createClass(r, [{
      key: "filter",
      value: function filter(t) {
        return t[this.itemAttr] === this.sel[this.itemAttr];
      }
    }, {
      key: "toStr",
      value: function toStr() {
        return "".concat(this.itemAttr, " == ").concat(this.sel[this.itemAttr]);
      }
    }]);

    return r;
  }();

  function i() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var o = "interpolateGreys" in t ? t.interpolateGreys : e.interpolateGreys;
    var r = t.scaleSequential(o).domain([32, 90]),
        i = t.map(),
        l = t.map();

    function a(t) {
      if ("string" != typeof t) return "white";
      var e = l.get(t.slice(0, n));
      return void 0 === e && (console.log("scaleText Couldn't find index for ".concat(t, " did you call domain? Using ascii of first letter")), e = t.slice(0, n).charCodeAt(0)), r(e) || "white";
    }

    function s(e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      i = t.map();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _t2 = _step.value;
          i.has(_t2) || i.set(_t2, 0), i.set(_t2, i.get(_t2) + 1);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var o = {
        counts: i
      };

      if (n) {
        l = t.map();
        var _e = 0;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = i.keys().sort()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _t = _step2.value;
            l.set(_t, _e++);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        o.indexes = l;
      }

      return o;
    }

    return a.digits = function (t) {
      return arguments.length ? (n = t, a) : n;
    }, a.scale = function (t) {
      return arguments.length ? (r = t, a) : r;
    }, a.domain = function (t) {
      return arguments.length ? (s(t.filter(function (t) {
        return "string" == typeof t;
      }).map(function (t) {
        return t.slice(0, n);
      })), r.domain([0, i.keys().length]), a) : r.domain();
    }, a.computeRepresentatives = s, a.__type = "text", a;
  }

  return function (l, a) {
    var s,
        d,
        c,
        p,
        u,
        f,
        h,
        g,
        v = this || {},
        m = [],
        y = [],
        b = [],
        x = [],
        w = t.map(),
        A = t.map(),
        _ = [],
        S = [],
        z = [],
        $ = [],
        C = [],
        k = void 0 !== a ? a : 600,
        E = t.map(),
        T = {
      x: -50,
      y: -50
    },
        B = "interpolateBlues" in t ? t.interpolateBlues : e.interpolateBlues,
        D = "interpolatePurples" in t ? t.interpolatePurples : e.interpolatePurples,
        M = "interpolateBrBG" in t ? t.interpolateBrBG : e.interpolateBrBG,
        P = ["#a1d76a", "#e9a3c9", "white"],
        F = ["white", "#b5cf6b"],
        q = "__seqId",
        N = function N() {};

    function O() {
      t.event.preventDefault();
    }

    function I() {
      g && g.remove(), (g = t.select("body").append("div").attr("class", "_nv_popover").style("pointer-events", "none").style("font-family", "sans-serif").style("font-size", v.tooltipFontSize).style("text-align", "center").style("background", v.tooltipBgColor).style("position", "relative").style("color", "black").style("z-index", 4).style("border-radius", "4px").style("box-shadow", "0 0 2px rgba(0,0,0,0.5)").style("padding", "10px").style("text-align", "center").style("display", "none")).append("style").attr("scoped", "").text("\n        [x-arrow] {\n          width: 0;\n          height: 0;\n          border-style: solid;\n          position: absolute;\n          margin: ".concat(v.tooltipArrowSize, "px;\n          border-color: ").concat(v.tooltipBgColor, "\n        }\n\n        ._nv_popover[x-placement=\"left\"] {\n            margin-right: ").concat(v.tooltipArrowSize + v.tooltipMargin, "px;\n        }\n\n        ._nv_popover[x-placement=\"left\"] [x-arrow] {\n          border-width: ").concat(v.tooltipArrowSize, "px 0 ").concat(v.tooltipArrowSize, "px ").concat(v.tooltipArrowSize, "px;\n          border-top-color: transparent;\n          border-right-color: transparent;\n          border-bottom-color: transparent;\n          right: -").concat(v.tooltipArrowSize, "px;\n          top: calc(50% - ").concat(v.tooltipArrowSize, "px);\n          margin-left: 0;\n          margin-right: 0;\n        }\n\n        ._nv_popover[x-placement=\"right\"] {\n            margin-left: ").concat(v.tooltipArrowSize + v.tooltipMargin, "px;\n        }\n\n        ._nv_popover[x-placement=\"right\"] [x-arrow] {\n          border-width: ").concat(v.tooltipArrowSize, "px ").concat(v.tooltipArrowSize, "px ").concat(v.tooltipArrowSize, "px 0;\n          border-left-color: transparent;\n          border-top-color: transparent;\n          border-bottom-color: transparent;\n          left: -").concat(v.tooltipArrowSize, "px;\n          top: calc(50% - ").concat(v.tooltipArrowSize, "px);\n          margin-left: 0;\n          margin-right: 0;\n        }\n\n        ._nv_popover[x-placement=\"bottom\"] {\n            margin-top: ").concat(v.tooltipArrowSize + v.tooltipMargin, "px;\n        }\n\n        ._nv_popover[x-placement=\"bottom\"] [x-arrow] {\n          border-width: 0 ").concat(v.tooltipArrowSize, "px ").concat(v.tooltipArrowSize, "px ").concat(v.tooltipArrowSize, "px;\n          border-left-color: transparent;\n          border-right-color: transparent;\n          border-top-color: transparent;\n          top: -").concat(v.tooltipArrowSize, "px;\n          left: calc(50% - ").concat(v.tooltipArrowSize, "px);\n          margin-top: 0;\n          margin-bottom: 0;\n        }\n\n        ._nv_popover[x-placement=\"top\"] {\n            margin-bottom: ").concat(v.tooltipArrowSize + v.tooltipMargin, "px;\n        }\n\n        ._nv_popover[x-placement=\"top\"] [x-arrow] {\n          border-width: ").concat(v.tooltipArrowSize, "px ").concat(v.tooltipArrowSize, "px 0 ").concat(v.tooltipArrowSize, "px;\n          border-left-color: transparent;\n          border-right-color: transparent;\n          border-bottom-color: transparent;\n          bottom: -").concat(v.tooltipArrowSize, "px;\n          left: calc(50% - ").concat(v.tooltipArrowSize, "px);\n          margin-top: 0;\n          margin-bottom: 0;\n        }\n\n\n      ")), g.append("div").attr("class", "tool_id"), g.append("div").attr("class", "tool_value_name").style("font-weight", "bold").style("font-size", "120%"), g.append("div").attr("class", "tool_value_val").style("max-width", "400px").style("max-height", "5.5em").style("text-align", "left").style("overflow", "hidden").style("font-size", "90%"), g.append("div").attr("x-arrow", ""), h = new n({
        getBoundingClientRect: function getBoundingClientRect() {
          var t = p.node().getBoundingClientRect();
          return {
            top: T.y + t.top,
            right: T.x + t.left,
            bottom: T.y + t.top,
            left: T.x + t.left,
            width: 0,
            height: 0
          };
        },
        clientWidth: 0,
        clientHeight: 0
      }, g.node(), {
        placement: "auto"
      });
    }

    function U(e) {
      t.select(e).style("cursor", "progress"), p.style("cursor", "progress");
    }

    function W(e) {
      t.select(e).style("cursor", null), p.style("cursor", null);
    }

    function R(e, n) {
      var o = e.domain(),
          r = e.range();
      return t.scaleQuantize().domain(r).range(o)(n);
    }

    function G(t, e) {
      if (!S.hasOwnProperty(t)) return;
      e = void 0 !== e ? e : y, performance.now();
      var n = S[t];
      e[t].sort(function (t, e) {
        return n.desc ? function (t, e) {
          return null == e ? null == t ? 0 : -1 : null == t ? 1 : t < e ? 1 : t > e ? -1 : t >= e ? 0 : NaN;
        }(m[t][n.attrib], m[e][n.attrib]) : function (t, e) {
          return null == e ? null == t ? 0 : 1 : null == t ? -1 : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
        }(m[t][n.attrib], m[e][n.attrib]);
      }), j(e[t], t), performance.now();
    }

    function K(e) {
      t.event && t.event.defaultPrevented || (S[e.level] = {
        attrib: e.attrib,
        desc: void 0 !== S[e.level] && S[e.level].attrib === e.attrib && !S[e.level].desc
      }, L(e.level + 1), G(e.level), V(e.level), v.updateData(y, E, {
        levelsToUpdate: [e.level]
      }), N(v.getVisible()));
    }

    function V(e) {
      e < 0 || t.select("#level" + e).selectAll(".brush").call(z[e].move, null);
    }

    function Y(t) {
      for (var e = 0; e < y.length; e += 1) {
        e !== t && V(e);
      }
    }

    function j(t, e) {
      for (var n = 0; n < t.length; n++) {
        m[t[n]].__i[e] = n;
      }
    }

    function L(t) {
      for (var _e2 = t; _e2 < $.length; _e2++) {
        $[_e2] = $[_e2].filter(function (t) {
          return !(t instanceof o);
        });
      }
    }

    function X(t, e) {
      var n, o;
      e = void 0 !== e ? e : y, n = performance.now();
      var r = e[t].filter(function (e) {
        m[e].selected = !1;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = $[t][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _n = _step3.value;

            if (_n.filter(m[e])) {
              m[e].selected = !0;
              break;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return m[e].selected;
      });
      return o = performance.now(), r;
    }

    function H(e) {
      var n = function () {
        var t = 0;

        for (var _e3 = 0; _e3 < $.length && (t = _e3, $[_e3] && $[_e3].length); _e3++) {
          ;
        }

        return t;
      }();

      var o = y;

      for (var _t3 = e; _t3 <= n; _t3++) {
        if (!$.hasOwnProperty(_t3) || !$[_t3].length) {
          o = ct(_t3 + 1, o, {
            shouldUpdate: !1
          });
          break;
        }

        var _e4 = X(_t3, o);

        j(_e4, _t3 + 1), _e4.length, v.nestedFilters && (o[_t3 + 1] = _e4), G(_t3 + 1);
      }

      v.updateData(o, E, {
        shouldDrawBrushes: !0,
        levelsToUpdate: t.range(e, o.length)
      }), N(v.getVisible());
    }

    function Q(e, n) {
      z[n] = t.brushY().extent([[d(s.domain()[0], n), C[n].range()[0]], [d(s.domain()[s.domain().length - 1], n) + 1.1 * s.bandwidth(), C[n].range()[1]]]).on("brush", function () {
        if (!t.event.sourceEvent) return;
        if (!t.event.selection) return;
        t.event.sourceEvent.clientX, t.event.sourceEvent.clientY;
        var e = t.event.sourceEvent.offsetX,
            o = t.event.sourceEvent.offsetY;
        J(e, o, 0, 0, n);
      }).on("end", function () {
        if (!t.event.sourceEvent) return;
        if (!t.event.selection) return;
        U(this), Y(n), performance.now();
        var e = t.event.selection,
            r = w.get(R(C[n], e[0])),
            i = w.get(R(C[n], e[1]));
        var l = new o({
          first: r,
          last: i,
          level: n,
          itemAttr: S[n] ? S[n].attrib : "__seqId"
        });
        t.event.sourceEvent.shiftKey ? ($.hasOwnProperty(n) || ($[n] = []), $[n].push(l)) : $[n] = [l], L(n + 1), H(n), performance.now(), W(this);
      });
      var i = t.select(this).selectAll(".brush").data([{
        data: e.map(function (t) {
          return m[t];
        }),
        level: n
      }]);
      i.enter().merge(i).append("g").on("mousemove", Z).on("click", function () {
        U(this);
        var e = t.mouse(t.event.target)[1];
        (function (e, o) {
          Y(-1), performance.now();
          var i = R(C[n], o),
              l = (performance.now(), R(s, e - c(n)));
          if (void 0 === l) return;
          var a = w.get(i);
          var d = new r({
            sel: a,
            itemAttr: l
          });
          t.event.shiftKey ? ($.hasOwnProperty(n) || ($[n] = []), $[n].push(d)) : $[n] = [d], L(n + 1), H(n);
        })(t.mouse(t.event.target)[0], e), W(this);
      }).on("mouseout", tt).attr("class", "brush").call(z[n]).selectAll("rect").attr("width", d(s.domain()[s.domain().length - 1], n) + 1.1 * s.bandwidth()), i.exit().remove();
    }

    function J(t, e, n, o, r) {
      var i = R(C[r], e),
          l = R(s, t - c(r)),
          a = w.get(i);
      a && void 0 !== a ? (T.x = t, T.y = e, g.select(".tool_id").text(i), g.select(".tool_value_name").text(l), g.select(".tool_value_val").text(a[l]), g.style("display", "initial"), h.scheduleUpdate()) : console.log("Couldn't find datum for tooltip y", e, a);
    }

    function Z(e) {
      var n = t.mouse(t.event.target)[0],
          o = t.mouse(t.event.target)[1];
      t.event.clientX, t.event.clientY, e.data && J(n, o, 0, 0, e.level);
    }

    function tt() {
      T.x = -200, T.y = -200, g.style("display", "none"), h.scheduleUpdate();
    }

    function et(t, e) {
      var n = s.domain()[s.domain().length - 1],
          o = e.append("g").attr("class", "filterExplanation");
      o.merge(t.select(".filterExplanation")).attr("transform", function (t, e) {
        return "translate(".concat(function (t) {
          return d(n, t) + s.bandwidth() + 2;
        }(e), ", ").concat(C[e].range()[1] + 1.2 * v.filterFontSize, ")");
      }), o.append("rect").merge(t.select("rect.bgExplanation")).attr("class", "bgExplanation").style("fill", "white").attr("x", 0).attr("y", .3 * v.filterFontSize).attr("width", c.bandwidth()).attr("height", function (t, e) {
        return $[e] ? $[e].length * v.filterFontSize * 1.3 : 0;
      });
      var r = o.append("text").style("font-size", v.filterFontSize).merge(t.select(".filterExplanation > text")).selectAll("tspan").data(function (t, e) {
        return $[e] ? $[e].map(function (t) {
          return t.level = e, t;
        }) : [];
      });
      r.enter().append("tspan").merge(r).attr("dy", 1.2 * v.filterFontSize).attr("x", 0).style("cursor", "not-allowed").text(function (t) {
        return "Ⓧ " + t.toStr();
      }).on("click", function (t, e) {
        console.log("Click remove filter", e, t), $[t.level].splice(e, 1), H(t.level);
      }), r.exit().remove();
    }

    function nt(e, n) {
      var o;
      v.showAttribTitles && n.append("text").merge(e.select("text")).style("cursor", "point").style("-webkit-user-select", "none").style("-moz-user-select", "none").style("-ms-user-select", "none").style("user-select", "none").text(function (t) {
        return "__seqId" === t.attrib ? "sequential Index" : t.attrib + (void 0 !== S[t.level] && S[t.level].attrib === t.attrib ? S[t.level].desc ? " ↓" : " ↑" : "");
      }).attr("x", s.bandwidth() / 2).attr("y", 0).style("font-weight", function (t) {
        return void 0 !== S[t.level] && S[t.level].attrib === t.attrib ? "bolder" : "normal";
      }).style("font-family", "sans-serif").style("font-size", function (t) {
        return Math.min(v.attribFontSize, v.attribWidth) + "px";
      }).on("click", (o = K, function (t, e, n) {
        var _this = this;

        U(this), requestAnimationFrame(function () {
          o(t, e, n), W(_this);
        });
      })).call(t.drag().container(n.merge(e).node()).on("start", rt).on("drag", it).on("end", lt)).on("mousemove", function () {
        var e = t.select(this);
        (e = void 0 !== e.transition ? e.transition().duration(150) : e).style("font-size", v.attribFontSizeSelected + "px");
      }).on("mouseout", function () {
        var e = t.select(this);
        (e = void 0 !== e.transition ? e.transition().duration(150) : e).style("font-size", Math.min(v.attribFontSize, v.attribWidth) + "px");
      }).attr("transform", "rotate(".concat(v.attribRotation, ")"));
    }

    function ot(t) {
      var e = p.select(".attribs").selectAll(".levelOverlay").data(y),
          n = e.enter().append("g");
      n.attr("class", "levelOverlay").attr("id", function (t, e) {
        return "level" + e;
      }), t ? n.merge(e).each(Q) : n.each(Q), function (t, e) {
        var n = s.domain(),
            o = e.merge(t).selectAll(".attribOverlay").data(function (t, e) {
          return n.map(function (t) {
            return {
              attrib: t,
              level: e
            };
          });
        }),
            r = o.enter().append("g").attr("class", "attribOverlay").style("cursor", "pointer");
        r.merge(o).attr("transform", function (t) {
          return "translate(".concat(d(t.attrib, t.level), ", ").concat(C[t.level].range()[0], ")");
        }), r.append("rect").merge(o.select("rect")).attr("fill", "none").attr("x", 0).attr("y", 0).attr("width", function () {
          return 1.1 * s.bandwidth();
        }).attr("height", function (t) {
          return C[t.level].range()[1] - C[t.level].range()[0];
        }), nt(o, r), o.exit().remove();
      }(e, n), function (t, e) {
        e.append("text").merge(t.select("text.numNodesLabel")).attr("class", "numNodesLabel").style("font-family", "sans-serif").style("pointer-events", "none").attr("y", function (t, e) {
          return C[e].range()[1] + 15;
        }).attr("x", function (t, e) {
          return c(e);
        }).text(function (t) {
          return v.fmtCounts(t.length);
        });
      }(e, n), et(e, n), e.exit().remove();
    }

    function rt(e) {
      t.event.sourceEvent.shiftKey && t.select(this.parentNode).attr("transform", function (e) {
        return "translate(" + (t.event.x + v.attribFontSize / 2) + "," + C[e.level].range()[0] + ")";
      });
    }

    function it() {
      t.event.sourceEvent.shiftKey && t.select(this.parentNode).attr("transform", function (e) {
        return "translate(" + (t.event.x + v.attribFontSize / 2) + "," + C[e.level].range()[0] + ")";
      });
    }

    function lt(e) {
      if (t.event.sourceEvent.shiftKey) {
        var n,
            o = R(s, t.event.x + v.attribFontSize / 2 - c(e.level));
        t.select(this.parentNode).attr("transform", function (t) {
          return "translate(" + d(t.attrib, t.level) + "," + C[t.level].range()[0] + ")";
        }), o !== e.attrib && (n = _.indexOf(o), pt(e.attrib, n), v.updateData(y));
      }
    }

    function at(t) {
      var e = s.domain()[s.domain().length - 1],
          n = d(e, y.length - 1) + s.bandwidth() + 2,
          o = C[y.length - 1](t.source[q]) + C[y.length - 1].bandwidth() / 2,
          r = C[y.length - 1](t.target[q]) + C[y.length - 1].bandwidth() / 2,
          i = Math.min(o, r),
          l = Math.max(o, r),
          a = l - i;
      f.moveTo(n, i), f.quadraticCurveTo(n + a / 6, i + a / 2, n, l);
    }

    function st(t, e, n, o) {
      f.beginPath(), t.forEach(function (t, e) {
        0 === e ? f.moveTo(t.x, t.y) : f.lineTo(t.x, t.y);
      }), f.lineWidth = e, o ? (f.fillStyle = n, f.closePath(), f.fill()) : (f.strokeStyle = n, f.stroke());
    }

    function dt(e) {
      var _ref = e || {},
          n = _ref.levelsToUpdate,
          o = _ref.shouldUpdateColorDomains;

      performance.now();
      var r = y.length - 1;
      n = void 0 !== n ? n : [r], o = void 0 !== o && o, C.splice(r + 1, C.length), n.forEach(function (e) {
        C[e] = t.scaleBand().range([v.y0, k - v.margin - 30]).paddingInner(0).paddingOuter(0);

        var n = function (t) {
          var e = [];

          if (y[t].length > k) {
            var _n2 = Math.max(Math.floor(y[t].length / (2 * k)), 1);

            y[t].itemsPerpixel = _n2;

            for (var _o = 0; _o < y[t].length; _o += _n2) {
              e.push(y[t][_o]);
            }
          } else y[t].itemsPerpixel = 1, e = y[t];

          return y[t].representatives = e, e;
        }(e);

        C[e].domain(n.map(function (t) {
          return m[t][q];
        }));
      }), s.domain(_).range([0, v.attribWidth * A.keys().length]).paddingInner(.1).paddingOuter(0), c.domain(y.map(function (t, e) {
        return e;
      })).range([v.x0 + v.margin, (s.range()[1] + v.levelsSeparation) * y.length + v.x0]).paddingInner(0).paddingOuter(0), o && A.keys().forEach(function (e) {
        if ("selected" !== e) {
          var n = E.get(e);
          if ("seq" === n.__type || "date" === n.__type) n.domain(t.extent(y[0].map(function (t) {
            return m[t][e];
          })));else if ("div" === n.__type) {
            var _t$extent = t.extent(y[0].map(function (t) {
              return m[t][e];
            })),
                _t$extent2 = _slicedToArray(_t$extent, 2),
                _o2 = _t$extent2[0],
                _r = _t$extent2[1],
                _i = Math.max(-_o2, _r);

            n.domain([-_i, _i]);
          } else "text" === n.__type && n.domain(y[0].map(function (t) {
            return m[t][e];
          }));
          E.set(e, n);
        }
      }), performance.now();
    }

    function ct(t, e, n) {
      if (y.length <= 1) return;

      var _ref2 = n || {},
          o = _ref2.shouldUpdate,
          r = void 0 !== t ? t : y.length - 1;

      return o = void 0 === o || o, (e = void 0 !== e ? e : y).hasOwnProperty(r) ? (U(this), r > 0 && (V(r - 1), e[r - 1].forEach(function (t) {
        return m[t].selected = !0;
      }), $.hasOwnProperty(r - 1) && $[r - 1].length && $[r - 1].forEach(function (t, e) {
        return delete $[r - 1][e];
      }), $[r - 1] = []), e.splice(r), o && (v.updateData(e, E), N(v.getVisible())), W(this), e) : e;
    }

    function pt(t, e) {
      var n = _.indexOf(t);

      -1 !== n ? e > _.length || e < 0 ? console.err("moveAttrToPos pos out of bounds", e, _.length) : (_.splice(n, 1), _.splice(e, 0, t)) : console.err("moveAttrToPos attr not found", t);
    }

    function ut() {
      b.length > 0 && (x = b.filter(function (t) {
        return t.source.selected && t.target.selected;
      }));
    }

    function ft(t, e) {
      var n;
      !function (t) {
        f.save(), f.beginPath(), f.rect(c(t), C[t].range()[0] - 1, s.range()[1] + 1, C[t].range()[1] + 2 - C[t].range()[0]), f.strokeStyle = "black", f.lineWidth = 1, f.stroke(), f.restore();
      }(e), t.representatives.forEach(function (t) {
        !function (t, e) {
          var n, o, r;

          for (f.save(), o = 0; o < _.length; o++) {
            if (n = _[o], r = Math.round(C[e](t[q]) + C[e].bandwidth() / 2), f.beginPath(), f.moveTo(Math.round(d(n, e)), r), f.lineTo(Math.round(d(n, e) + s.bandwidth()), r), f.lineWidth = Math.ceil(C[e].bandwidth()), f.strokeStyle = void 0 === t[n] || null === t[n] || "" === t[n] || "none" === t[n] ? v.nullColor : E.get(n)(t[n]), f.stroke(), C[e].bandwidth() > 2 * v.divisionsThreshold) {
              var i = Math.round(C[e](t[q]));
              f.beginPath(), f.moveTo(d(n, e), i), f.lineTo(d(n, e) + s.bandwidth(), i), f.lineWidth = 1, f.strokeStyle = v.divisionsColor, f.stroke();
            }
          }

          f.restore();
        }(m[t], e);
      }), (n = e) <= 0 || y[n].representatives.forEach(function (t) {
        var e = w.get(m[t][q]).__i[n - 1],
            o = Math.floor(e - e % y[n - 1].itemsPerpixel),
            r = {
          x: c(n - 1) + s.range()[1],
          y: C[n - 1](m[y[n - 1][o]][q])
        },
            i = {
          x: c(n),
          y: C[n](m[t][q])
        },
            l = [r, {
          x: r.x + .3 * v.levelsSeparation,
          y: r.y
        }, {
          x: i.x - .3 * v.levelsSeparation,
          y: i.y
        }, i, {
          x: i.x,
          y: i.y + C[n].bandwidth()
        }, {
          x: i.x - .3 * v.levelsSeparation,
          y: i.y + C[n].bandwidth()
        }, {
          x: r.x + .3 * v.levelsSeparation,
          y: r.y + C[n - 1].bandwidth()
        }, {
          x: r.x,
          y: r.y + C[n - 1].bandwidth()
        }, r];

        st(l, 1, v.levelConnectionsColor), st(l, 1, v.levelConnectionsColor, !0);
      });
    }

    return v.x0 = 0, v.y0 = 100, v.maxNumDistictForCategorical = 10, v.howManyItemsShouldSearchForNotNull = 100, v.margin = 30, v.levelsSeparation = 40, v.divisionsColor = "white", v.nullColor = "#ffedfd", v.levelConnectionsColor = "rgba(205, 220, 163, 0.5)", v.divisionsThreshold = 4, v.fmtCounts = t.format(",.0d"), v.legendFont = "14px sans-serif", v.linkColor = "#ccc", v.nestedFilters = !0, v.showAttribTitles = !0, v.attribWidth = 15, v.attribRotation = -45, v.attribFontSize = 13, v.attribFontSizeSelected = 32, v.filterFontSize = 10, v.tooltipFontSize = 12, v.tooltipBgColor = "#b2ddf1", v.tooltipMargin = 50, v.tooltipArrowSize = 10, v.initData = function (e, n) {
      performance.now(), (E = n).keys().forEach(function (t) {
        A.set(t, !0);
      }), w = t.map();

      for (var o = 0; o < m.length; o++) {
        var r = m[o];
        r.__seqId = o, w.set(r[q], r), r.__i = [], r.__i[0] = o;
      }

      ($ = [])[0] = [], performance.now();
    }, v.updateData = function (e, n, o) {
      var _ref3 = o || {},
          r = _ref3.levelsToUpdate,
          i = _ref3.shouldUpdateColorDomains,
          l = _ref3.shouldDrawBrushes,
          a = _ref3.recomputeBrushes;

      performance.now(), typeof e == typeof [] ? (E = void 0 !== n ? n : E, y = e, $.splice(e.length), $[e.length] = [], ut(), z.splice(e.length), dt({
        levelsToUpdate: r,
        shouldUpdateColorDomains: i
      }), function () {
        var e = c.range()[1] + v.margin + v.x0;
        t.select(u).attr("width", e).attr("height", k).style("width", e).style("height", k + "px"), u.style.width = e + "px", u.style.height = k + "px", p.attr("width", e).attr("height", k);
      }(), v.update({
        levelsToUpdate: r,
        shouldDrawBrushes: l,
        recomputeBrushes: a
      }), performance.now()) : console.error("navio updateData didn't receive an array");
    }, v.update = function (t) {
      var _ref4 = t || {},
          e = _ref4.recomputeBrushes,
          n = _ref4.levelsToUpdate,
          o = _ref4.shouldDrawBrushes;

      if (!y.length) return v;
      e = void 0 !== e && e, o = void 0 === o || o, performance.now();
      var r,
          i = c.range()[1] + v.margin + v.x0;
      return f.clearRect(0, 0, i + 1, k + 1), b.length && (f.save(), f.beginPath(), f.strokeStyle = v.linkColor, f.globalAlpha = Math.min(1, Math.max(.1, 1e3 / b[b.length - 1].length)), x.forEach(at), f.stroke(), f.restore()), y.forEach(ft), o && (ot(e), r = y.length - 1, p.select("#closeButton").style("display", 1 === y.length ? "none" : "block").attr("transform", "translate(" + (c(r) + c.bandwidth() - v.levelsSeparation + 15) + "," + C[r].range()[0] + ")")), performance.now(), v;
    }, v.addAttrib = function (t, e) {
      if (-1 === _.indexOf(t)) return _.push(t), E.set(t, e), v;
    }, v.addSequentialAttrib = function (e, n) {
      var o = void 0 !== m && m.length > 0 ? t.extent(m, function (t) {
        return t[e];
      }) : [0, 1],
          r = n || t.scaleSequential(B).domain(o);
      return r.__type = "seq", v.addAttrib(e, r), v;
    }, v.addDateAttrib = function (e, n) {
      var o = void 0 !== m && m.length > 0 ? t.extent(m, function (t) {
        return t[e];
      }) : [0, 1],
          r = n || t.scaleSequential(D).domain(o);
      return v.addAttrib(e, r), r.__type = "date", v;
    }, v.addDivergingAttrib = function (e, n) {
      var o = void 0 !== m && m.length > 0 ? t.extent(m, function (t) {
        return t[e];
      }) : [-1, 1],
          r = n || t.scaleSequential(M).domain([o[0], o[1]]);
      return r.__type = "div", v.addAttrib(e, r), v;
    }, v.addCategoricalAttrib = function (e, n) {
      var o = n || t.scaleOrdinal(t.schemeCategory10);
      return o.__type = "cat", v.addAttrib(e, o), v;
    }, v.addTextAttrib = function (t, e) {
      var n = e || i();
      return v.addAttrib(t, n), v;
    }, v.addBooleanAttrib = function (e, n) {
      var o = n || t.scaleOrdinal().domain([!0, !1, null]).range(P);
      return o.__type = "bool", v.addAttrib(e, o), v;
    }, v.addAllAttribs = function (e) {
      if (!m || !m.length) throw Error("addAllAttribs called without data to guess the attribs. Make sure to call it after setting the data");
      return (void 0 !== e ? e : function (t) {
        var e,
            n = [];

        for (e in t) {
          t.hasOwnProperty(e) && n.push(e);
        }

        return n;
      }(m[0])).forEach(function (e) {
        if ("__seqId" === e || "__i" === e || "selected" === e) return;

        var n = function (t, e) {
          var n, o;

          for (n = 0; n < v.howManyItemsShouldSearchForNotNull && n < t.length; n++) {
            if (null != (o = t[n][e]) && "" !== o) return o;
          }

          return o;
        }(m, e);

        if (null == n || "string" == typeof n) {
          var _t4 = i().computeRepresentatives(m.slice(0, v.howManyItemsShouldSearchForNotNull).map(function (t) {
            return t[e];
          })).counts;
          _t4.keys().length < v.maxNumDistictForCategorical ? (console.log("Navio: Adding attr ".concat(e, " as categorical")), v.addCategoricalAttrib(e)) : (console.log("Navio: Attr ".concat(e, " has too many distinct elements (").concat(_t4.keys().length, ") using textAttrib")), v.addTextAttrib(e));
        } else "number" == typeof n ? t.min(m, function (t) {
          return t[e];
        }) < 0 ? (console.log("Navio: Adding attr ".concat(e, " as diverging")), v.addDivergingAttrib(e)) : (console.log("Navio: Adding attr ".concat(e, " as sequential")), v.addSequentialAttrib(e)) : typeof n == typeof new Date() ? (console.log("Navio: Adding attr ".concat(e, " as date")), v.addDateAttrib(e)) : typeof n == typeof !0 ? (console.log("Navio: Adding attr ".concat(e, " as boolean")), v.addBooleanAttrib(e)) : (console.log("Navio: Don't know what to do with attr ".concat(e, " adding as categorical (type=").concat(typeof n, ")")), v.addCategoricalAttrib(e));
      }), v.data(m), v;
    }, v.data = function (e) {
      return I(), E.has("selected") || (v.addAttrib("selected", t.scaleOrdinal().domain([!1, !0]).range(F)), pt("selected", 0)), E.has("__seqId") || (v.addSequentialAttrib("__seqId"), pt("__seqId", 1)), arguments.length ? ((m = e.slice(0)).forEach(function (t) {
        t.selected = !0;
      }), y = [m.map(function (t, e) {
        return e;
      })], v.initData(y, E), _.length > 2 && v.updateData(y, E, {
        shouldUpdateColorDomains: !0
      }), v) : m[0];
    }, v.getSelected = function () {
      return y[y.length - 1].filter(function (t) {
        return m[t].selected;
      }).map(function (t) {
        return m[t];
      });
    }, v.getVisible = v.getSelected, v.sortBy = function (t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = arguments.length > 2 ? arguments[2] : undefined;
      var o = Math.max(0, void 0 !== n && n < y.length ? n : y.length - 1);
      return void 0 !== t ? (S[o] = {
        attrib: t,
        desc: e
      }, v.update()) : S[o];
    }, v.updateCallback = function (t) {
      return arguments.length ? (N = t, v) : N;
    }, v.selectedColorRange = function (t) {
      return arguments.length ? (F = t, v) : F;
    }, v.defaultColorInterpolator = function (t) {
      return arguments.length ? (B = t, v) : B;
    }, v.id = function (t) {
      return arguments.length ? (q = t, v) : q;
    }, v.links = function (t) {
      return arguments.length ? (b = t, ut(), v) : b;
    }, function () {
      (l = void 0 === (l = "string" == typeof l ? t.select(l) : l).selectAll ? t.select(l) : l).selectAll("*").remove();
      var e = l.on("touchstart", O).on("touchmove", O).style("height", k + "px").attr("class", "navio").append("div").style("position", "relative");
      e.append("canvas"), (p = e.append("svg").style("overflow", "visible").style("position", "absolute").style("z-index", 3).style("top", 0).style("left", 0)).append("g").attr("class", "attribs"), I(), p.append("g").attr("id", "closeButton").style("fill", "white").style("stroke", "black").style("display", "none").append("path").call(function (e) {
        var n = t.path();
        n.moveTo(0, 0), n.lineTo(7, 7), n.moveTo(7, 0), n.lineTo(0, 7), n.moveTo(11.9, 3.5), n.arc(3.5, 3.5, 8.4, 0, 2 * Math.PI), e.attr("d", n.toString());
      }).on("click", function () {
        return ct();
      }), s = t.scaleBand().range([0, v.attribWidth]).round(!0).paddingInner(.1).paddingOuter(0), c = t.scaleBand().round(!0), E = t.map(), d = function d(t, e) {
        return c(e) + s(t);
      }, (u = l.select("canvas").node()).style.top = u.offsetTop + "px", u.style.left = u.offsetLeft + "px", u.style.height = k + "px";
      var n = window.devicePixelRatio;
      u.height = k * n, (f = u.getContext("2d")).scale(n, n), f.imageSmoothingEnabled = f.mozImageSmoothingEnabled = f.webkitImageSmoothingEnabled = !1, f.globalCompositeOperation = "source-over";
    }(), v;
  };
});